import { render, staticRenderFns } from "./FootbtnTwo.vue?vue&type=template&id=121b688f&scoped=true&"
import script from "./FootbtnTwo.vue?vue&type=script&lang=js&"
export * from "./FootbtnTwo.vue?vue&type=script&lang=js&"
import style0 from "./FootbtnTwo.vue?vue&type=style&index=0&id=121b688f&prod&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121b688f",
  null
  
)

export default component.exports